import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import 'components/Icon/font/style.css';
import 'components/Icon/png/style.css';

const propTypes = {
  name: PropTypes.string
};

const defaultProps = {
  name: ''
};

const Icon = ({ name, className, title, disabled, ...props }) => (
  <i
    {...props}
    title={title || ''}
    style={{
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled && '30%',
      display: 'inline-block',
      margin: props.project == 'br' ? 0 : null,
      width: props.width ? props.width : null,
      height: props.height ? props.height : null,
    }}
    onMouseDown={(e) => { if (props.onMouseDown) props.onMouseDown(e); }}
    onClick={(e) => { if (props.onClick && !disabled) props.onClick(e); }}
    className={`icon-${name} ${className || ''}`}
  />
);

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default styled(Icon)``;